import { Divider, Form, Typography } from 'antd';
import Input from '../../../Input';
import { useForm } from '../../context';

const { Link } = Typography;

interface IProps {
  name?: (string | number)[];
}

const BasicInfoResumed = ({ name }: IProps) => {
  name = name ?? [];

  const { isOCB, ocbData, disableOCB, checkout } = useForm();

  let customer = checkout?.customer;

  if (ocbData?.customer && !customer) {
    customer = ocbData.customer;
  }

  if (!customer) {
    return null;
  }

  return (
    <>
      <p className='text-center'>
        Olá, <strong>{customer.name}!</strong> Que bom ter você de volta por aqui!
      </p>

      {isOCB && (
        <p className='text-center'>
          <Link onClick={() => disableOCB()}>Clique aqui</Link>, caso não seja você.
        </p>
      )}

      <Form.Item name={[...name, 'id']} hidden noStyle>
        <Input hidden />
      </Form.Item>

      <Divider variant='dashed' />
    </>
  );
};

export default BasicInfoResumed;
